export default function ErrorPage() {
	return <div>Ooops something went wrong</div>;
}
